import React, { useContext, useEffect, useState } from 'react';
import InputRegister from '../../blocks/ui/InputDesign';
import { clientValidate, organisationValidate } from '../../../utils/validator';
import { DContext } from '../../../context/Datacontext';

import { useNavigate, useParams } from 'react-router-dom';
import { fetchClient, updateClient } from '../../services/managerApi/clientsApi';
import { compressImage } from '../../../utils/compressImages';


export default function UpdateClient() {
  const { BeURL, showAlert, currentUser } = useContext(DContext)

  const { clientId } = useParams()

  const [client, setClient] = useState(null)

  const [errors, setErrors] = useState({ client: {} })

  const [logoPreview, setLogoPreview] = useState("")
  const [clientLogo, setClientLogo] = useState("")

  const navigate = useNavigate()

  const handleClient = (name, value, checked) => {

    const finalValue = name === "isActive" ? checked : value;

    setClient(prev => ({
      ...prev,
      [name]: finalValue,
    }));

    let errmsg;
    errmsg = clientValidate(name, finalValue);

    setErrors((prev) => ({
      ...prev,
      client: {
        ...prev.client,
        [name]: errmsg,
      },
    }));
  };

  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const handleLogoChange = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    if (!file.type || !file.type.startsWith("image/")) {
      setErrors((prev) => ({
        ...prev,
        client: { ...prev.client, clientLogo: "Only image files are allowed" }
      }));
      setClientLogo("");
      setLogoPreview("");
      return;
    }

    setErrors((prev) => ({
      ...prev,
      client: { ...prev.client, clientLogo: "" }
    }));

    const compressedFile = await compressImage(file, { maxSizeMB: 0.7 });
    const base64 = await fileToBase64(compressedFile);
    setClientLogo(base64);
    setLogoPreview(base64);
  };

  // fetch particula Client
  useEffect(() => {


    const fetchClients = async () => {
      await fetchClient(BeURL, showAlert, setClient, clientId)
    }
    fetchClients()

  }, [])

  useEffect(() => {
    if (client?.logo) {
      setLogoPreview(client.logo);
    }
  }, [client]);


  const isFormValid = (errors) => {
    // Check if all error objects are empty
    return (
      Object.values(errors.client || {}).every((err) => !err)
    )
  }

  const handleCreate = async () => {

    console.log("client.clientWebsite", client.clientWebsite)
    const payload = {
      'clientName': client.clientName,
      'clientWebsite': client.clientWebsite,
      'industry': client.industry,
      'isActive': client.isActive,
      'userId': currentUser._id,

    }

    if (clientLogo) {
      payload.clientLogo = clientLogo;
    }

    await updateClient(BeURL, showAlert, payload, setClient, clientId, currentUser.company.companyId, navigate)
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white shadow-xl rounded-2xl w-full max-w-5xl p-8">
        <h2 className="text-3xl font-bold mb-8 text-primary-600 text-center">
          Update Client
        </h2>

        <div className="grid grid-cols-2 gap-4">

          {[{
            label: "Client Name", name: "clientName", value: client?.clientName, error: errors.client?.clientName, mandatory: true, placeholder: "Company Name",
            required: true
          },
          {
            label: " Client Website", name: "clientWebsite", value: client?.clientWebsite, error: errors.client?.clientWebsite, placeholder: "Ex: https://www.example.com/",
            required: true
          },
          {
            label: "Industry", name: "industry", value: client?.industry ? client.industry.charAt(0).toUpperCase() + client.industry.slice(1) : "",
            error: errors.client?.industry, mandatory: true, placeholder: "Company Industry Type",
          },].map((field, idx) => (
            <div key={idx} className="bg-gray-50 p-4 rounded-xl shadow-inner">
              <InputRegister
                label={field.label}
                value={field.value}
                name={field.name}
                mandatory={field.mandatory}
                required
                placeholder={field.placeholder}
                type="text"
                className="w-full"
                error={field.error}
                onChange={(e) => handleClient(e.target.name, e.target.value)}
              />
            </div>


          ))}
          <div className="bg-gray-50 p-4 rounded-xl shadow-inner">
            <label className="block text-sm font-medium text-gray-700 mb-2">Client Logo (optional)</label>
            {logoPreview ? (
              <img src={logoPreview} alt="Client Logo" className="h-20 w-20 object-contain rounded border mb-2" />
            ) : null}
            <input
              type="file"
              accept="image/*"
              onChange={handleLogoChange}
              className="w-full"
            />
            {errors.client?.clientLogo ? (
              <p className="text-xs text-red-500 mt-1">{errors.client.clientLogo}</p>
            ) : null}
          </div>
          <div className='flex items-center px-7'>
            <input type="checkbox" className="w-5 px-10"
              name="isActive" checked={client?.isActive}
              onChange={(e) => handleClient(e.target.name, e.target.value, e.target.checked)}
            />Active
          </div>


          <div className="md:col-span-2 flex justify-center mt-4">
            <button
              type="submit"
              disabled={!isFormValid(errors)}
              className={`px-4 py-2 rounded ${isFormValid(errors)
                ? "bg-secondary-200 text-white hover:bg-secondary-500"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
              onClick={handleCreate}
            >
              Update Client
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
